<script>
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import ListGroup from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListGroup.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";
  import Separator from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Separator.svelte";
  import { teamHasDiallerStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import SnoozeInput from "../components/SnoozeInput.svelte";
  import { todoPanelStore } from "../stores";
  import { saveModalStatus } from "./utils";

  let closeDropdown;
  const options = [
    {
      title: "Stop Outreach",
      items: [
        {
          icon: "fa-calendar-day",
          text: "Meeting scheduled",
          outcome: "booked",
        },
        { icon: "fa-face-smile", text: "Interested", outcome: "interested" },
        {
          icon: "fa-face-frown",
          text: "Not interested",
          outcome: "notInterested",
        },
      ],
    },
    {
      title: "Continue Outreach",
      items: [
        {
          icon: "fa-phone-arrow-up-right",
          text: "Call back later",
          outcome: "callBackLater",
        },
        { icon: "fa-phone-xmark", text: "No answer", outcome: "noAnswer" },
      ],
    },
  ];
  const makeListItemClick =
    ({ outcome }) =>
    () => {
      $todoPanelStore.outcome = outcome;
      $todoPanelStore.status = "done";
      closeDropdown();

      return saveModalStatus();
    };

  $: kind = $teamHasDiallerStore ? "secondary" : "primary";
</script>

<Dropdown
  placement="top"
  class="flex-1"
  size="large"
  {kind}
  bind:close={closeDropdown}
>
  <span slot="button">Log call outcome</span>
  {#each options as group, groupIndex}
    <ListGroup title={group.title}>
      {#each group.items as item}
        {@const { icon, text, outcome } = item}
        {#if outcome === "callBackLater"}
          <SnoozeInput callBackLater={true} placement="left" {closeDropdown} />
        {:else}
          <ListItem {icon} onclick={makeListItemClick(item)}>{text}</ListItem>
        {/if}
      {/each}
    </ListGroup>
    {#if groupIndex !== options.length - 1}
      <Separator />
    {/if}
  {/each}
</Dropdown>
